'use client'

import { Dialog, DialogClose, DialogContent } from '@/components/ui/dialog'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { MoveUpRight, X } from 'lucide-react'
import { Label } from '@/components/ui/label'
import { Separator } from '@/components/ui/separator'
import { useState } from 'react'

const LoginModal = ({ open, onOpenChange }) => {
  const [tab, setTab] = useState('login')
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card [&>button]:hidden md:max-w-[480px] max-w-[90%] pb-5">
        <div className="w-full mt-5 h-[60px] px-[30px] border-b">
          <h2 className="text-typography text-xl font-semibold">Welcome to Soukna</h2>
          <DialogClose className="absolute top-4 right-6 p-2 rounded-full bg-gray-200 hover:bg-gray-300">
            <X className="w-5 h-5 text-gray-600" />
          </DialogClose>
        </div>
        <Tabs
          value={tab}
          onValueChange={setTab}
          defaultValue="login"
          className="w-full pt-[30px] px-[30px]"
        >
          <TabsList className="inline-flex h-9 items-center text-muted-foreground w-full !border-none justify-start rounded-none bg-transparent p-0 mb-4">
            <TabsTrigger
              className="inline-flex items-center justify-center whitespace-nowrap py-1 text-sm relative h-9 rounded-none border-b-[3px] border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold shadow-none transition-none data-[state=active]:border-b-typography data-[state=active]:text-typography data-[state=active]:shadow-none data-[state=inactive]:text-muted data-[state=active]:bg-input"
              value="login"
            >
              Sign In
            </TabsTrigger>
            <TabsTrigger
              className="inline-flex items-center justify-center whitespace-nowrap py-1 text-sm relative h-9 rounded-none border-b-[3px] border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold shadow-none transition-none data-[state=active]:border-b-typography data-[state=active]:text-typography data-[state=active]:shadow-none data-[state=inactive]:text-muted data-[state=active]:bg-input"
              value="register"
            >
              New Account
            </TabsTrigger>
          </TabsList>

          {/* Sign In Tab */}
          <TabsContent value="login" className="my-4">
            <div className="space-y-4">
              <div className="space-y-2">
                <Label className="text-typography font-medium">Email</Label>
                <Input type="email" placeholder="Enter Email" className="rounded-md md:h-[50px]" />
              </div>
              <div className="space-y-2">
                <Label className="text-typography font-medium">Password</Label>
                <Input
                  type="password"
                  placeholder="Enter Password"
                  className="rounded-md md:h-[50px]"
                />
              </div>

              <Button className="w-full text-white bg-primary hover:bg-primary-300 transition-colors text-[15px] font-semibold space-x-4 md:h-[55px]">
                Sign in
                <MoveUpRight />
              </Button>

              <div className="w-full h-8 grid grid-cols-[1fr_auto_1fr] place-content-center place-items-center">
                <div className="h-[1px] w-full bg-border"></div>
                <p className="text-typography mx-2">OR</p>
                <div className="h-[1px] w-full bg-border"></div>
              </div>

              <Button className="w-full flex gap-2 border md:h-[55px] px-5" variant="outline">
                <img src="/icons/google.svg" alt="" />
                <span className="flex-grow text-center">Continue Google</span>
              </Button>
              <Button className="w-full flex gap-2 bg-blue-600 hover:bg-blue-700 text-white md:h-[55px] px-5">
                <img src="/icons/facebook.svg" alt="" />
                <span className="flex-grow text-center">Continue Facebook</span>
              </Button>
              <p className="text-typography text-center text-sm leading-[26px]">
                Not signed up?{' '}
                <span
                  onClick={() => setTab('register')}
                  className="text-typography cursor-pointer font-semibold"
                >
                  Create an account.
                </span>
              </p>
            </div>
          </TabsContent>

          {/* Register Tab */}
          <TabsContent value="register" className="my-4">
            <div className="space-y-4">
              <div className="space-y-2">
                <Label className="text-typography font-medium">Full Name</Label>
                <Input
                  type="text"
                  placeholder="Enter Full Name"
                  className="rounded-md md:h-[50px]"
                />
              </div>
              <div className="space-y-2">
                <Label className="text-typography font-medium">Email</Label>
                <Input type="email" placeholder="Enter Email" className="rounded-md md:h-[50px]" />
              </div>
              <div className="space-y-2">
                <Label className="text-typography font-medium">Password</Label>
                <Input
                  type="password"
                  placeholder="Enter Password"
                  className="rounded-md md:h-[50px]"
                />
              </div>

              <Button className="w-full text-white bg-primary hover:bg-primary-300 transition-colors text-[15px] font-semibold space-x-4 md:h-[55px]">
                Create Account
                <MoveUpRight />
              </Button>
            </div>
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  )
}

export default LoginModal
